import React, { useState, useRef, useEffect } from 'react';
import Grid from '@mui/material/Grid2';
import { PlusCircle, Minus, ChevronLeft, Plus } from 'react-feather';
import {
    Box,
    Button,
    TextField,
    Typography,
    Autocomplete,
    Switch,
    FormControlLabel,
    Checkbox,
    IconButton,
    InputAdornment
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { authApi } from '../../api/api';
import Toastmessage from '../../components/Toast';
import { logout } from '../../features/auth/AuthSlice';
import { useParams } from 'react-router-dom';

const RequiredLabel = ({ children }) => (
    <>
        {children} <span style={{ color: 'red' }}>*</span>
    </>
);

export default function AddClient() {
    const { id } = useParams();
    const fileInputRef = useRef(null);
    const [formData, setFormData] = useState({ Estate: '', client: { id: '', full_name: '' } });
    const [active, setActive] = useState(true);
    const [errors, setErrors] = useState({});
    const [clientNameOptions, setClientNameOptions] = useState([]);
    const [realEstateForms, setRealEstateForms] = useState([]);
    const [vehiclesForms, setVehiclesForms] = useState([]);
    const [financialForms, setFinancialForms] = useState([]);
    const [insuranceForms, setInsuranceForms] = useState([]);
    const [propertyForms, setPropertyForms] = useState([]);
    const [otherAssetsForms, setOtherAssetsForms] = useState([]);
    const [isLoading, setIsloading] = useState(false);


    const token = useSelector((state_id) => state_id.auth.token);
    const userID = useSelector((state_id) => state_id.auth.id);

    const [assets, setAssets] = useState([]);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const location = useLocation();
    const { estateID } = location.state || {};


    const inputRefs = useRef({});

    const [assetTypes, setAssetTypes] = useState({
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
    });

    useEffect(() => {
        setAssetTypes((prev) => ({
            ...prev,
            1: realEstateForms.length > 0,
            2: vehiclesForms.length > 0,
            3: financialForms.length > 0,
            4: insuranceForms.length > 0,
            5: propertyForms.length > 0,
            6: otherAssetsForms.length > 0,
        }));
    }, [realEstateForms, vehiclesForms, financialForms, insuranceForms, propertyForms, otherAssetsForms]);

    const handleCheckboxChange = (type) => {
        setAssetTypes((prev) => {
            const newState = { ...prev, [type]: !prev[type] };

            const createFormData = (dataTemplate) => {
                return newState[type] ? [{ id: Date.now(), property_id: 1, data: { ...dataTemplate, property_id: 1 } }] : [];
            };

            if (type === 1) {
                setRealEstateForms(createFormData({ PropertyName: '', propertyAddress: '', value: '', mortgageAmount: '', otherOwners: '', ticOrJwros: '', available_value: "", available_percentage: 100,balance_value:"" }));
            }
            if (type === 2) {
                setVehiclesForms(createFormData({ vehiclesName: '', yearMakeModel: '', value: '', loanBalance: '', otherOwners: '', vin: '', ticOrJwros: '', available_value: "", available_percentage: 100 ,balance_value:""}));
            }
            if (type === 3) {
                setFinancialForms(createFormData({ institutionName: '', accountNumber: '', accountType: '', otherOwners: '', beneficiary: '', value: '', available_value: "", available_percentage: 100 ,balance_value:""}));
            }
            if (type === 4) {
                setInsuranceForms(createFormData({ institutionName: '', policyNumber: '', value: '', beneficiaries: '', available_value: "", available_percentage: 100,balance_value:"" }));
            }
            if (type === 5) {
                setPropertyForms(createFormData({ propertyName: '', description: '', location: '', value: '', available_value: "", available_percentage: 100,balance_value:"" }));
            }
            if (type === 6) {
                setOtherAssetsForms(createFormData({ assetsName: '', description: '', value: '', information: '', available_value: "", available_percentage: 100,balance_value:"" }));
            }

            return newState;
        });
    };

    const addForm = (setForms) => {
        setForms((prev) => {
            const newPropertyId = prev.length + 1;
            return [
                ...prev,
                { id: Date.now(), property_id: newPropertyId, data: { property_id: newPropertyId } }
            ];
        });
    };

    const removeForm = (setForms, id) => {
        setForms((prev) => {
            const updatedForms = prev.filter((form) => form.id !== id);
            return updatedForms.map((form, index) => ({
                ...form,
                property_id: index + 1,
                data: { ...form.data, property_id: index + 1 }
            }));
        });
    };


    const handleInputChange = (setForms, id, field, value) => {
        setForms((prevForms) =>
            prevForms.map((form) =>
                form.id === id ? { ...form, data: { ...form.data, [field]: value } } : form
            )
        );
    };

    useEffect(() => {
        fetchClient();
        fetchAssets()
    }, [token, userID]);

    useEffect(() => {
        if (estateID) {
            fetchEstate(estateID);
        }
    }, [estateID]);


    const fetchEstate = async (estateID) => {
        const input_token = estateID + 'VIEW_ESTATE'; // Replace with your actual token
        const apiUrl = 'view_estate'; // Replace with the actual API endpoint

        const dataInput = {
            id: estateID,
            login_user_id: userID
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);
            if (data && data.success) {

                setActive(!!data.estate_detail.status);

                setFormData(prevFormData => ({
                    ...prevFormData,
                    Estate: data.estate_detail.estate_name,
                    client: {
                        ...prevFormData.client,
                        id: data.estate_detail.clients.id,
                        full_name: data.estate_detail.clients.name
                    }
                }));

                const assetData = JSON.parse(data.estate_detail.property_details); // Parse the response
                // Map the keys in `assetData` to their respective state-setting functions
                const setFunctionsMap = {
                    "1": setRealEstateForms,
                    "2": setVehiclesForms,
                    "3": setFinancialForms,
                    "4": setInsuranceForms,
                    "5": setPropertyForms,
                    "6": setOtherAssetsForms,
                };

                // Iterate through the keys in `assetData`
                Object.keys(assetData).forEach((key) => {
                    const setFunction = setFunctionsMap[key];
                    if (setFunction) {
                        // Transform the data to include unique IDs and match the desired structure
                        const transformedData = assetData[key].map((item) => ({
                            id: `${Date.now()}-${Math.random()}`, // Unique ID using Date.now() and a random number
                            data: { ...item }, // Keep all fields as is
                        }));

                        // Update the corresponding state
                        setFunction(transformedData);
                    }
                });


            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };

    const fetchAssets = async () => {
        const input_token = 'ASSET_TYPE_DROPDOWN'; // Replace with your actual token
        const apiUrl = 'asset_types_dropdown'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);


            if (data && data.success) {
                setAssets(data.asset_type_list);
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };


    const fetchClient = async () => {
        const input_token = 'CLIENTS';
        const apiUrl = 'list_of_clients';

        const dataInput = {
            login_user_id: userID
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data) {
                setClientNameOptions(data.client_list);
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }
        } catch (error) {
            console.error("Error fetching clients:", error);
        }
    };


    const handleSubmit = (event) => {
        event.preventDefault();
        const validationErrors = {};

        // Validate Estate and Client
        if (!formData.Estate) {
            validationErrors.Estate = "Estate name is required";
        }
        if (!formData.client?.id) {
            validationErrors.clientname = "Client is required";
        }

        // Validate each Real Estate form
        realEstateForms.forEach((form) => {
            if (!form.data.PropertyName) {
                validationErrors[`PropertyName-${form.id}`] = "Property Name is required";
            }
            if (!form.data.propertyAddress) {
                validationErrors[`propertyAddress-${form.id}`] = "Property address is required";
            }
            if (!form.data.value || form.data.value == 0) {
                validationErrors[`value-${form.id}`] = "Value is required and cannot be 0";
            }
            if (form.data.mortgageAmount === 0) {
                validationErrors[`mortgageAmount-${form.id}`] = "Mortgage amount cannot be 0";
            }
            if (!form.data.otherOwners) {
                validationErrors[`otherOwners-${form.id}`] = "Names of other owners are required";
            }
            if (!form.data.ticOrJwros) {
                validationErrors[`ticOrJwros-${form.id}`] = "TIC or JWROS is required";
            }
        });

        // Validate each Vehicle form
        vehiclesForms.forEach((form) => {
            if (!form.data.vehiclesName) {
                validationErrors[`vehiclesName-${form.id}`] = "Vehicle Name is required";
            }
            if (!form.data.yearMakeModel) {
                validationErrors[`yearMakeModel-${form.id}`] = "Year, Make, and Model is required";
            }
            if (!form.data.value || form.data.value == 0) {
                validationErrors[`value-${form.id}`] = "Vehicle value is required and cannot be 0";
            }
            if (form.data.loanBalance === 0) {
                validationErrors[`loanBalance-${form.id}`] = "Loan balance cannot be 0";
            }
            if (!form.data.otherOwners) {
                validationErrors[`otherOwners-${form.id}`] = "Names of other owners are required";
            }
            if (!form.data.vin) {
                validationErrors[`vin-${form.id}`] = "VIN is required";
            }
            if (!form.data.ticOrJwros) {
                validationErrors[`ticOrJwros-${form.id}`] = "TIC or JWROS is required";
            }
        });

        // Validate each Financial Account form
        financialForms.forEach((form) => {
            if (!form.data.institutionName) {
                validationErrors[`institutionName-${form.id}`] = "Institution name is required";
            }
            if (!form.data.accountNumber) {
                validationErrors[`accountNumber-${form.id}`] = "Account number is required";
            }
            if (!form.data.accountType) {
                validationErrors[`accountType-${form.id}`] = "Account type is required";
            }
            if (!form.data.otherOwners) {
                validationErrors[`otherOwners-${form.id}`] = "Names of other owners are required";
            }
            if (!form.data.beneficiary) {
                validationErrors[`beneficiary-${form.id}`] = "Beneficiary designation is required";
            }
            if (!form.data.value || form.data.value == 0) {
                validationErrors[`value-${form.id}`] = "Account balance is required and cannot be 0";
            }
        });

        // Validate each Life Insurance form
        insuranceForms.forEach((form) => {
            if (!form.data.institutionName) {
                validationErrors[`institutionName-${form.id}`] = "Institution name is required";
            }
            if (!form.data.policyNumber) {
                validationErrors[`policyNumber-${form.id}`] = "Policy number is required";
            }
            if (!form.data.value || form.data.value == 0) {
                validationErrors[`value-${form.id}`] = "Benefits amount is required and cannot be 0";
            }
            if (!form.data.beneficiaries) {
                validationErrors[`beneficiaries-${form.id}`] = "Beneficiaries are required";
            }
        });

        // Validate each Personal Property form
        propertyForms.forEach((form) => {
            if (!form.data.propertyName) {
                validationErrors[`propertyName-${form.id}`] = "Property Name is required";
            }
            if (!form.data.description) {
                validationErrors[`description-${form.id}`] = "Description is required";
            }
            // if (!form.data.location) {
            //     validationErrors[`location-${form.id}`] = "Location is required";
            // }
            if (!form.data.value || form.data.value == 0) {
                validationErrors[`value-${form.id}`] = "Value is required and cannot be 0";
            }
        });

        // Validate each Other Assets form
        otherAssetsForms.forEach((form) => {
            if (!form.data.assetsName) {
                validationErrors[`assetsName-${form.id}`] = "Assets Name is required";
            }
            if (!form.data.description) {
                validationErrors[`description-${form.id}`] = "Description is required";
            }
            if (!form.data.value || form.data.value == 0) {
                validationErrors[`value-${form.id}`] = "Value is required and cannot be 0";
            }
            if (!form.data.information) {
                validationErrors[`information-${form.id}`] = "Information is required";
            }
        });

        setErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) return;

        const addEstateApi = async () => {
            setIsloading(true)
            const input_token = estateID + 'UPDATE_ESTATE';
            const apiUrl = 'update_estate';

            const datainput = {
                id: estateID,
                auth_token: token, // Token from Redux state
                login_user_id: userID, // User ID from Redux state
                estate_name: formData.Estate,
                client_id: formData.client.id, // Start date
                status: active ? 1 : 0,
                property_details: {
                    ...(realEstateForms.length > 0 && { 1: realEstateForms.map(form => form.data) }),
                    ...(vehiclesForms.length > 0 && { 2: vehiclesForms.map(form => form.data) }),
                    ...(financialForms.length > 0 && { 3: financialForms.map(form => form.data) }),
                    ...(insuranceForms.length > 0 && { 4: insuranceForms.map(form => form.data) }),
                    ...(propertyForms.length > 0 && { 5: propertyForms.map(form => form.data) }),
                    ...(otherAssetsForms.length > 0 && { 6: otherAssetsForms.map(form => form.data) }),
                }
            };

            
            try {
                const data = await authApi(input_token, datainput, apiUrl, token, true);

                if (data && data.success) {
                    await Toastmessage(data.message, true);
                    setTimeout(() => navigate(-1), 2000);
                } else if (data && data.message === 'Token has expired') {
                    setIsloading(false)
                    dispatch(logout());
                    localStorage.removeItem('token');
                    await Toastmessage('Session expired. Redirecting to login...', false);
                    navigate('/login');
                } else if (data === undefined) {
                    setIsloading(false)
                    await Toastmessage('No response from server', false);
                } else {
                    setIsloading(false)
                    await Toastmessage(data?.message || 'An error occurred', false);
                }
            } catch (error) {
                setIsloading(false)
                console.error("Error fetching data:", error);
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    localStorage.removeItem('token');
                    await Toastmessage('Session expired. Redirecting to login...', false);
                    navigate('/login');
                } else {
                    await Toastmessage('Something went wrong', false);
                }
            }
        };

        addEstateApi();
    };


    return (
        <Box>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                marginBottom='20px'
                backgroundColor='var(--theme-bg-light)'
                padding={2}
                borderRadius={1}
            >
                <Typography fontSize={12} color="var(--text-color)">
                    Edit Estate
                </Typography>
                <Button
                    variant="outlined"
                    component={Link}
                    to="/estate"
                    sx={{
                        backgroundColor: 'var(--back-button)',
                        color: "var(--back-color)",
                        fontWeight: 'bold',
                        border: 'none',
                        padding: '10px 20px'
                    }}
                    startIcon={<ChevronLeft sx={{ fontSize: 17 }} />}
                    style={{ textTransform: 'none' }}
                >
                    Back Estate list
                </Button>
            </Box>
            <Box className="card-box" sx={{ p: { xs: 2, sm: 2, md: 3 }, m: { xs: 1, sm: 2, md: 3 }, border: '1px solid var(--border-color)', borderRadius: '8px' }}>
                <Box className="sub-header">
                    <Typography sx={{ color: '#3570FF', fontSize: '14px', fontWeight: 'bold' }}>
                        Edit Estate
                    </Typography>
                    <FormControlLabel
                        control={<Switch checked={active} onChange={(e) => setActive(e.target.checked)} />}
                        label={
                            <Typography sx={{ color: active ? 'green' : 'red', fontWeight: 'bold' }}>
                                Active : {active ? 'Yes' : 'No'}
                            </Typography>
                        }
                    />
                </Box>

                <Grid container spacing={3}>
                    <Grid size={{ xs: 12, md: 3 }}>
                        <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}><RequiredLabel>Estate Name</RequiredLabel></Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter the Estate Name"
                            error={!!errors.Estate}
                            helperText={errors.Estate}
                            value={formData.Estate}
                            name="Estate"
                            onChange={(event) => setFormData({ ...formData, Estate: event.target.value })}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 3 }}>
                        <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}><RequiredLabel>Select Client</RequiredLabel></Typography>
                        <Autocomplete
                            options={clientNameOptions}
                            getOptionLabel={(option) => option.full_name}
                            value={formData.client || null}
                            onChange={(event, newValue) => setFormData({ ...formData, client: newValue })}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Select client"
                                    variant="outlined"
                                    error={!!errors.clientname}
                                    helperText={errors.clientname}
                                    InputProps={{
                                        ...params.InputProps,
                                        sx: { borderRadius: '8px' },
                                    }}
                                />
                            )}
                            sx={{ width: '100%' }}
                        />
                    </Grid>
                </Grid>

                <Box>
                    <Typography sx={{ my: 1, fontWeight: '500', color: '#595A63' }}><RequiredLabel>Assets Type</RequiredLabel></Typography>
                    <Box display="flex" gap={2} mb={2}>
                        {assets?.map((asset) => (
                            <Box key={asset.id} display="flex" alignItems="center" gap={1}>
                                <Checkbox
                                    checked={!!assetTypes[asset.id]}
                                    onChange={() => handleCheckboxChange(asset.id)}
                                    sx={{
                                        transform: "scale(0.7)",
                                        borderRadius: "8px",
                                        padding: "2px",
                                        "&.Mui-checked": {
                                            color: "#3570FF",
                                        },
                                    }}
                                />
                                <Typography variant="body2">{asset.asset_type}</Typography>
                            </Box>
                        ))}
                    </Box>

                    {assetTypes[1] && (
                        <Box border="1px solid var(--text-field-border)" borderRadius={1} p={2} mt={2}>
                            <Grid container spacing={2}>
                                <Grid size={6}>
                                    <Typography variant="h6">Real Estate</Typography>
                                </Grid>
                                <Grid size={6} display={'flex'} justifyContent={'end'}>
                                    <Plus size={20} onClick={() => addForm(setRealEstateForms)} />
                                </Grid>
                            </Grid>

                            <Box>
                                {realEstateForms.map((form) => (
                                    <Box key={form.id} p={2} mb={2} border="1px solid #E1E1E1" backgroundColor={"#F3F4FC"} borderRadius={1}>
                                        <Grid container spacing={2} position="relative">
                                            <IconButton
                                                sx={{ position: 'absolute', right: 0, top: -14 }}
                                                color="error"
                                                onClick={() => removeForm(setRealEstateForms, form.id)}
                                            >
                                                <Minus size={20} />
                                            </IconButton>

                                            <Grid size={4}>
                                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}><RequiredLabel>Property Name</RequiredLabel></Typography>
                                                <TextField
                                                    placeholder="Property Name"
                                                    fullWidth
                                                    sx={{ backgroundColor: 'white', borderRadius: '8px' }}
                                                    value={form.data.PropertyName}
                                                    onChange={(e) => handleInputChange(setRealEstateForms, form.id, 'PropertyName', e.target.value)}
                                                    error={!!errors[`PropertyName-${form.id}`]}
                                                    helperText={errors[`PropertyName-${form.id}`] || ''}
                                                />
                                            </Grid>

                                            <Grid size={4}>
                                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}><RequiredLabel>Real Estate Address of Property</RequiredLabel></Typography>
                                                <TextField
                                                    placeholder="Real Estate Address of Property"
                                                    fullWidth
                                                    sx={{ backgroundColor: 'white', borderRadius: '8px' }}
                                                    value={form.data.propertyAddress}
                                                    onChange={(e) => handleInputChange(setRealEstateForms, form.id, 'propertyAddress', e.target.value)}
                                                    error={!!errors[`propertyAddress-${form.id}`]}
                                                    helperText={errors[`propertyAddress-${form.id}`] || ''}
                                                />
                                            </Grid>

                                            <Grid size={4}>
                                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}>
                                                    Value
                                                </Typography>
                                                <TextField
                                                    type="text"
                                                    placeholder="Real Estate Value"
                                                    fullWidth
                                                    sx={{
                                                        backgroundColor: 'white', borderRadius: '8px', backgroundColor: 'white',
                                                        borderRadius: '8px',
                                                        '& input[type=number]': {
                                                            '-moz-appearance': 'textfield',
                                                        },
                                                        '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
                                                            '-webkit-appearance': 'none',
                                                            margin: 0,
                                                        },
                                                    }}
                                                    value={form.data.value}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (/^\d{0,9}$/.test(value)) {
                                                            const intValue = parseInt(value, 10) || null;
                                                            handleInputChange(setRealEstateForms, form.id, 'value', intValue);
                                                            handleInputChange(setRealEstateForms, form.id, 'available_value', intValue);
                                                            handleInputChange(setRealEstateForms, form.id, 'balance_value', intValue);
                                                        }
                                                    }}
                                                    error={!!errors[`value-${form.id}`]}
                                                    helperText={errors[`value-${form.id}`] || ''}
                                                    slotProps={{
                                                        input: {
                                                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                                        },
                                                    }}
                                                />
                                            </Grid>

                                            <Grid size={4}>
                                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}>Mortgage Amount</Typography>
                                                <TextField
                                                    type="text"
                                                    placeholder="Real Estate Mortgage Amount"
                                                    fullWidth
                                                    sx={{ backgroundColor: 'white', borderRadius: '8px' ,  backgroundColor: 'white',
                                                        borderRadius: '8px',
                                                        '& input[type=number]': {
                                                            '-moz-appearance': 'textfield',
                                                        },
                                                        '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
                                                            '-webkit-appearance': 'none',
                                                            margin: 0,
                                                        },}}
                                                    value={form.data.mortgageAmount}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (/^\d{0,9}$/.test(value)) {
                                                            const intValue = value === '' ? null : parseInt(value, 10);
                                                            handleInputChange(setRealEstateForms, form.id, 'mortgageAmount', intValue);
                                                        }
                                                    }}
                                                    slotProps={{
                                                        input: {
                                                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                                        },
                                                    }}
                                                    error={!!errors[`mortgageAmount-${form.id}`]}
                                                    helperText={errors[`mortgageAmount-${form.id}`] || ''}
                                                />
                                            </Grid>


                                            <Grid size={4}>
                                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}><RequiredLabel>Names of Other Owners</RequiredLabel></Typography>
                                                <TextField
                                                    placeholder="Names of Other Owners"
                                                    fullWidth
                                                    sx={{ backgroundColor: 'white', borderRadius: '8px' }}
                                                    value={form.data.otherOwners}
                                                    onChange={(e) => handleInputChange(setRealEstateForms, form.id, 'otherOwners', e.target.value)}
                                                    error={!!errors[`otherOwners-${form.id}`]}
                                                    helperText={errors[`otherOwners-${form.id}`] || ''}
                                                />
                                            </Grid>

                                            <Grid size={4}>
                                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}><RequiredLabel>TIC or JWROS</RequiredLabel></Typography>
                                                <TextField
                                                    placeholder="Real Estate TIC or JWROS"
                                                    fullWidth
                                                    sx={{ backgroundColor: 'white', borderRadius: '8px' }}
                                                    value={form.data.ticOrJwros}
                                                    onChange={(e) => handleInputChange(setRealEstateForms, form.id, 'ticOrJwros', e.target.value)}
                                                    error={!!errors[`ticOrJwros-${form.id}`]}
                                                    helperText={errors[`ticOrJwros-${form.id}`] || ''}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    )}

                    {assetTypes[2] && (
                        <Box border="1px solid var(--text-field-border)" borderRadius={1} p={2} mt={2}>
                            <Grid container spacing={2}>
                                <Grid size={6}>
                                    <Typography variant="h6">Vehicle</Typography>
                                </Grid>
                                <Grid size={6} display={'flex'} justifyContent={'end'}>
                                    <Plus size={20} onClick={() => addForm(setVehiclesForms)} />
                                </Grid>
                            </Grid>

                            <Box>
                                {vehiclesForms.map((form) => (
                                    <Box key={form.id} p={2} mb={2} border="1px solid #E1E1E1" backgroundColor={"#F3F4FC"} borderRadius={1}>
                                        <Grid container spacing={2} position="relative">
                                            <IconButton
                                                sx={{ position: 'absolute', right: 0, top: -14 }}
                                                color="error"
                                                onClick={() => removeForm(setVehiclesForms, form.id)}
                                            >
                                                <Minus size={20} />
                                            </IconButton>

                                            <Grid size={4}>
                                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}><RequiredLabel>Vehicle Name</RequiredLabel></Typography>
                                                <TextField
                                                    placeholder="Enter the details"
                                                    fullWidth
                                                    sx={{ backgroundColor: 'white', borderRadius: '8px' }}
                                                    value={form.data.vehiclesName}
                                                    onChange={(e) => handleInputChange(setVehiclesForms, form.id, 'vehiclesName', e.target.value)}
                                                    error={!!errors[`vehiclesName-${form.id}`]}
                                                    helperText={errors[`vehiclesName-${form.id}`] || ''}
                                                />
                                            </Grid>

                                            <Grid size={4}>
                                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}><RequiredLabel>Vehicle Year, Make, and Model</RequiredLabel></Typography>
                                                <TextField
                                                    placeholder="Enter the details"
                                                    fullWidth
                                                    sx={{ backgroundColor: 'white', borderRadius: '8px' }}
                                                    value={form.data.yearMakeModel}
                                                    onChange={(e) => handleInputChange(setVehiclesForms, form.id, 'yearMakeModel', e.target.value)}
                                                    error={!!errors[`yearMakeModel-${form.id}`]}
                                                    helperText={errors[`yearMakeModel-${form.id}`] || ''}
                                                />
                                            </Grid>

                                            <Grid size={4}>
                                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}><RequiredLabel>Vehicle Value</RequiredLabel></Typography>
                                                <TextField
                                                    type="text"
                                                    placeholder="Enter the value"
                                                    fullWidth
                                                    sx={{ backgroundColor: 'white', borderRadius: '8px' ,  backgroundColor: 'white',
                                                        borderRadius: '8px',
                                                        '& input[type=number]': {
                                                            '-moz-appearance': 'textfield',
                                                        },
                                                        '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
                                                            '-webkit-appearance': 'none',
                                                            margin: 0,
                                                        },}}
                                                    value={form.data.value}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (/^\d{0,9}$/.test(value)) {
                                                            const intValue = parseInt(value, 10) || null;
                                                            handleInputChange(setVehiclesForms, form.id, 'value', intValue);
                                                            handleInputChange(setVehiclesForms, form.id, 'available_value', intValue);
                                                            handleInputChange(setVehiclesForms, form.id, 'balance_value', intValue);
                                                        }
                                                    }}
                                                    slotProps={{
                                                        input: {
                                                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                                        },
                                                    }}
                                                    error={!!errors[`value-${form.id}`]}
                                                    helperText={errors[`value-${form.id}`] || ''}
                                                />
                                            </Grid>

                                            <Grid size={4}>
                                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}><RequiredLabel>Vehicle Loan Balance</RequiredLabel></Typography>
                                                <TextField
                                                    type="text"
                                                    placeholder="Enter the amount"
                                                    fullWidth
                                                    sx={{ backgroundColor: 'white', borderRadius: '8px' }}
                                                    value={form.data.loanBalance}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (/^\d{0,9}$/.test(value)) {
                                                            const intValue = value === '' ? null : parseInt(value, 10);
                                                            handleInputChange(setVehiclesForms, form.id, 'loanBalance', intValue);
                                                          }
                                                    }}
                                                    slotProps={{
                                                        input: {
                                                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                                        },
                                                    }}
                                                    error={!!errors[`loanBalance-${form.id}`]}
                                                    helperText={errors[`loanBalance-${form.id}`] || ''}
                                                />
                                            </Grid>


                                            <Grid size={4}>
                                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}><RequiredLabel>Name of Other Owners</RequiredLabel></Typography>
                                                <TextField
                                                    placeholder="Enter the details"
                                                    fullWidth
                                                    sx={{ backgroundColor: 'white', borderRadius: '8px' }}
                                                    value={form.data.otherOwners}
                                                    onChange={(e) => handleInputChange(setVehiclesForms, form.id, 'otherOwners', e.target.value)}
                                                    error={!!errors[`otherOwners-${form.id}`]}
                                                    helperText={errors[`otherOwners-${form.id}`] || ''}
                                                />
                                            </Grid>

                                            <Grid size={4}>
                                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}><RequiredLabel>Vehicle VIN</RequiredLabel></Typography>
                                                <TextField
                                                    placeholder="Enter the details"
                                                    fullWidth
                                                    sx={{ backgroundColor: 'white', borderRadius: '8px' }}
                                                    value={form.data.vin}
                                                    onChange={(e) => handleInputChange(setVehiclesForms, form.id, 'vin', e.target.value)}
                                                    error={!!errors[`vin-${form.id}`]}
                                                    helperText={errors[`vin-${form.id}`] || ''}
                                                />
                                            </Grid>

                                            <Grid size={4}>
                                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}><RequiredLabel>Vehicle TIC or JWROS</RequiredLabel></Typography>
                                                <TextField
                                                    placeholder="Enter the details"
                                                    fullWidth
                                                    sx={{ backgroundColor: 'white', borderRadius: '8px' }}
                                                    value={form.data.ticOrJwros}
                                                    onChange={(e) => handleInputChange(setVehiclesForms, form.id, 'ticOrJwros', e.target.value)}
                                                    error={!!errors[`ticOrJwros-${form.id}`]}
                                                    helperText={errors[`ticOrJwros-${form.id}`] || ''}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    )}

                    {assetTypes[3] && (
                        <Box border="1px solid var(--text-field-border)" borderRadius={1} p={2} mt={2}>
                            <Grid container spacing={2}>
                                <Grid size={6}>
                                    <Typography variant="h6">Financial Accounts</Typography>
                                </Grid>
                                <Grid size={6} display={'flex'} justifyContent={'end'}>
                                    <Plus size={20} onClick={() => addForm(setFinancialForms)} />
                                </Grid>
                            </Grid>

                            <Box>
                                {financialForms.map((form) => (
                                    <Box key={form.id} p={2} mb={2} border="1px solid #E1E1E1" backgroundColor={"#F3F4FC"} borderRadius={1}>
                                        <Grid container spacing={2} position="relative">
                                            <IconButton
                                                sx={{ position: 'absolute', right: 0, top: -14 }}
                                                color="error"
                                                onClick={() => removeForm(setFinancialForms, form.id)}
                                            >
                                                <Minus size={20} />
                                            </IconButton>

                                            <Grid size={4}>
                                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}><RequiredLabel>Financial Institution Name</RequiredLabel></Typography>
                                                <TextField
                                                    placeholder="Enter the details"
                                                    fullWidth
                                                    sx={{ backgroundColor: 'white', borderRadius: '8px' }}
                                                    value={form.data.institutionName}
                                                    onChange={(e) => handleInputChange(setFinancialForms, form.id, 'institutionName', e.target.value)}
                                                    error={!!errors[`institutionName-${form.id}`]}
                                                    helperText={errors[`institutionName-${form.id}`] || ''}
                                                />
                                            </Grid>

                                            <Grid size={4}>
                                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}><RequiredLabel>Financial Account Number</RequiredLabel></Typography>
                                                <TextField
                                                    type="text"
                                                    placeholder="Enter the number"
                                                    fullWidth
                                                    sx={{ backgroundColor: 'white', borderRadius: '8px' }}
                                                    value={form.data.accountNumber}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (/^\d{0,9}$/.test(value)) {
                                                            handleInputChange(setFinancialForms, form.id, 'accountNumber', value);
                                                        }
                                                    }}
                                                    error={!!errors[`accountNumber-${form.id}`]}
                                                    helperText={errors[`accountNumber-${form.id}`] || ''}
                                                />
                                            </Grid>


                                            <Grid size={4}>
                                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}><RequiredLabel>Financial Account Type</RequiredLabel></Typography>
                                                <TextField
                                                    placeholder="Enter the type"
                                                    fullWidth
                                                    sx={{ backgroundColor: 'white', borderRadius: '8px' }}
                                                    value={form.data.accountType}
                                                    onChange={(e) => handleInputChange(setFinancialForms, form.id, 'accountType', e.target.value)}
                                                    error={!!errors[`accountType-${form.id}`]}
                                                    helperText={errors[`accountType-${form.id}`] || ''}
                                                />
                                            </Grid>

                                            <Grid size={4}>
                                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}><RequiredLabel>Name of other Owners</RequiredLabel></Typography>
                                                <TextField
                                                    placeholder="Enter the details"
                                                    fullWidth
                                                    sx={{ backgroundColor: 'white', borderRadius: '8px' }}
                                                    value={form.data.otherOwners}
                                                    onChange={(e) => handleInputChange(setFinancialForms, form.id, 'otherOwners', e.target.value)}
                                                    error={!!errors[`otherOwners-${form.id}`]}
                                                    helperText={errors[`otherOwners-${form.id}`] || ''}
                                                />
                                            </Grid>

                                            <Grid size={4}>
                                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}><RequiredLabel>Beneficiary Designation</RequiredLabel></Typography>
                                                <TextField
                                                    placeholder="Enter the details"
                                                    fullWidth
                                                    sx={{ backgroundColor: 'white', borderRadius: '8px' }}
                                                    value={form.data.beneficiary}
                                                    onChange={(e) => handleInputChange(setFinancialForms, form.id, 'beneficiary', e.target.value)}
                                                    error={!!errors[`beneficiary-${form.id}`]}
                                                    helperText={errors[`beneficiary-${form.id}`] || ''}
                                                />
                                            </Grid>

                                            <Grid size={4}>
                                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}><RequiredLabel>Financial Account Balance</RequiredLabel></Typography>
                                                <TextField
                                                    type="text"
                                                    placeholder="Enter the details"
                                                    fullWidth
                                                    sx={{ backgroundColor: 'white', borderRadius: '8px' ,  backgroundColor: 'white',
                                                        borderRadius: '8px',
                                                        '& input[type=number]': {
                                                            '-moz-appearance': 'textfield',
                                                        },
                                                        '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
                                                            '-webkit-appearance': 'none',
                                                            margin: 0,
                                                        },}}
                                                    value={form.data.value}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (/^\d{0,9}$/.test(value)) {
                                                            const intValue = parseInt(value, 10) || null;
                                                            handleInputChange(setFinancialForms, form.id, 'value', intValue);
                                                            handleInputChange(setFinancialForms, form.id, 'available_value', intValue);
                                                            handleInputChange(setFinancialForms, form.id, 'balance_value', intValue);
                                                        }
                                                    }}
                                                    slotProps={{
                                                        input: {
                                                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                                        },
                                                    }}
                                                    error={!!errors[`value-${form.id}`]}
                                                    helperText={errors[`value-${form.id}`] || ''}
                                                />
                                            </Grid>

                                        </Grid>
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    )}

                    {assetTypes[4] && (
                        <Box border="1px solid var(--text-field-border)" borderRadius={1} p={2} mt={2}>
                            <Grid container spacing={2}>
                                <Grid size={6}>
                                    <Typography variant="h6">Life Insurance</Typography>
                                </Grid>
                                <Grid size={6} display={'flex'} justifyContent={'end'}>
                                    <Plus size={20} onClick={() => addForm(setInsuranceForms)} />
                                </Grid>
                            </Grid>

                            <Box>
                                {insuranceForms.map((form) => (
                                    <Box key={form.id} p={2} mb={2} border="1px solid #E1E1E1" backgroundColor={"#F3F4FC"} borderRadius={1}>
                                        <Grid container spacing={2} position="relative">
                                            <IconButton
                                                sx={{ position: 'absolute', right: 0, top: -14 }}
                                                color="error"
                                                onClick={() => removeForm(setInsuranceForms, form.id)}
                                            >
                                                <Minus size={20} />
                                            </IconButton>

                                            <Grid size={4}>
                                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}><RequiredLabel>Life Insurance Institution Name</RequiredLabel></Typography>
                                                <TextField
                                                    placeholder="Enter the details"
                                                    fullWidth
                                                    sx={{ backgroundColor: 'white', borderRadius: '8px' }}
                                                    value={form.data.institutionName}
                                                    onChange={(e) => handleInputChange(setInsuranceForms, form.id, 'institutionName', e.target.value)}
                                                    error={!!errors[`institutionName-${form.id}`]}
                                                    helperText={errors[`institutionName-${form.id}`] || ''}
                                                />
                                            </Grid>

                                            <Grid size={4}>
                                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}><RequiredLabel>Life Insurance Policy Number</RequiredLabel></Typography>
                                                <TextField
                                                    placeholder="Enter the number"
                                                    fullWidth
                                                    sx={{ backgroundColor: 'white', borderRadius: '8px' }}
                                                    value={form.data.policyNumber}
                                                    onChange={(e) => handleInputChange(setInsuranceForms, form.id, 'policyNumber', e.target.value)}
                                                    error={!!errors[`policyNumber-${form.id}`]}
                                                    helperText={errors[`policyNumber-${form.id}`] || ''}
                                                />
                                            </Grid>

                                            <Grid size={4}>
                                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}><RequiredLabel>Life Insurance Benefits Amount</RequiredLabel></Typography>
                                                <TextField

                                                    placeholder="Enter the amount"
                                                    fullWidth
                                                    sx={{ backgroundColor: 'white', borderRadius: '8px' ,  backgroundColor: 'white',
                                                        borderRadius: '8px',
                                                        '& input[type=number]': {
                                                            '-moz-appearance': 'textfield',
                                                        },
                                                        '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
                                                            '-webkit-appearance': 'none',
                                                            margin: 0,
                                                        },}}
                                                    value={form.data.value}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (/^\d{0,9}$/.test(value)) {
                                                            const intValue = parseInt(value, 10) || null;
                                                            handleInputChange(setInsuranceForms, form.id, 'value', intValue);
                                                            handleInputChange(setInsuranceForms, form.id, 'available_value', intValue);
                                                            handleInputChange(setInsuranceForms, form.id, 'balance_value', intValue);
                                                        }
                                                    }}
                                                    slotProps={{
                                                        input: {
                                                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                                        },
                                                    }}
                                                    error={!!errors[`value-${form.id}`]}
                                                    helperText={errors[`value-${form.id}`] || ''}
                                                />
                                            </Grid>


                                            <Grid size={12}>
                                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}><RequiredLabel>Life Insurance Beneficiaries</RequiredLabel></Typography>
                                                <TextField
                                                    placeholder="Enter the details"
                                                    fullWidth
                                                    sx={{ backgroundColor: 'white', borderRadius: '8px' }}
                                                    value={form.data.beneficiaries}
                                                    onChange={(e) => handleInputChange(setInsuranceForms, form.id, 'beneficiaries', e.target.value)}
                                                    error={!!errors[`beneficiaries-${form.id}`]}
                                                    helperText={errors[`beneficiaries-${form.id}`] || ''}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    )}

                    {assetTypes[5] && (
                        <Box border="1px solid var(--text-field-border)" borderRadius={1} p={2} mt={2}>
                            <Grid container spacing={2}>
                                <Grid size={6}>
                                    <Typography variant="h6">Personal Property</Typography>
                                </Grid>
                                <Grid size={6} display={'flex'} justifyContent={'end'}>
                                    <Plus size={20} onClick={() => addForm(setPropertyForms)} />
                                </Grid>
                            </Grid>

                            <Box>
                                {propertyForms.map((form) => (
                                    <Box key={form.id} p={2} mb={2} border="1px solid #E1E1E1" backgroundColor={"#F3F4FC"} borderRadius={1}>
                                        <Grid container spacing={2} position="relative">
                                            <IconButton
                                                sx={{ position: 'absolute', right: 0, top: -14 }}
                                                color="error"
                                                onClick={() => removeForm(setPropertyForms, form.id)}
                                            >
                                                <Minus size={20} />
                                            </IconButton>

                                            <Grid size={4}>
                                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}><RequiredLabel>Property Name</RequiredLabel></Typography>
                                                <TextField
                                                    placeholder="Enter the details"
                                                    fullWidth
                                                    sx={{ backgroundColor: 'white', borderRadius: '8px' }}
                                                    value={form.data.propertyName}
                                                    onChange={(e) => handleInputChange(setPropertyForms, form.id, 'propertyName', e.target.value)}
                                                    error={!!errors[`propertyName-${form.id}`]}
                                                    helperText={errors[`propertyName-${form.id}`] || ''}
                                                />
                                            </Grid>

                                            <Grid size={4}>
                                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}><RequiredLabel>Property Item Description</RequiredLabel></Typography>
                                                <TextField
                                                    placeholder="Enter the details"
                                                    fullWidth
                                                    sx={{ backgroundColor: 'white', borderRadius: '8px' }}
                                                    value={form.data.description}
                                                    onChange={(e) => handleInputChange(setPropertyForms, form.id, 'description', e.target.value)}
                                                    error={!!errors[`description-${form.id}`]}
                                                    helperText={errors[`description-${form.id}`] || ''}
                                                />
                                            </Grid>

                                            <Grid size={4}>
                                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}>Personal Property Location</Typography>
                                                <TextField
                                                    placeholder="Enter the Location"
                                                    fullWidth
                                                    sx={{ backgroundColor: 'white', borderRadius: '8px' }}
                                                    value={form.data.location}
                                                    onChange={(e) => handleInputChange(setPropertyForms, form.id, 'location', e.target.value)}
                                                    error={!!errors[`location-${form.id}`]}
                                                    helperText={errors[`location-${form.id}`] || ''}
                                                />
                                            </Grid>

                                            <Grid size={4}>
                                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}><RequiredLabel>Personal Property Value</RequiredLabel></Typography>
                                                <TextField
                                                    placeholder="Enter the value"
                                                    fullWidth
                                                    sx={{ backgroundColor: 'white', borderRadius: '8px' ,  backgroundColor: 'white',
                                                        borderRadius: '8px',
                                                        '& input[type=number]': {
                                                            '-moz-appearance': 'textfield',
                                                        },
                                                        '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
                                                            '-webkit-appearance': 'none',
                                                            margin: 0,
                                                        },}}
                                                    value={form.data.value}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (/^\d{0,9}$/.test(value)) {
                                                            const intValue = parseInt(value, 10) || null;
                                                            handleInputChange(setPropertyForms, form.id, 'value', intValue);
                                                            handleInputChange(setPropertyForms, form.id, 'available_value', intValue);
                                                            handleInputChange(setPropertyForms, form.id, 'balance_value', intValue);
                                                        }
                                                    }}
                                                    slotProps={{
                                                        input: {
                                                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                                        },
                                                    }}
                                                    error={!!errors[`value-${form.id}`]}
                                                    helperText={errors[`value-${form.id}`] || ''}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    )}

                    {assetTypes[6] && (
                        <Box border="1px solid var(--text-field-border)" borderRadius={1} p={2} mt={2}>
                            <Grid container spacing={2}>
                                <Grid size={6}>
                                    <Typography variant="h6">Other Assets</Typography>
                                </Grid>
                                <Grid size={6} display={'flex'} justifyContent={'end'}>
                                    <Plus size={20} onClick={() => addForm(setOtherAssetsForms)} />
                                </Grid>
                            </Grid>

                            <Box>
                                {otherAssetsForms.map((form) => (
                                    <Box key={form.id} p={2} mb={2} border="1px solid #E1E1E1" backgroundColor={"#F3F4FC"} borderRadius={1}>
                                        <Grid container spacing={2} position="relative">
                                            <IconButton
                                                sx={{ position: 'absolute', right: 0, top: -14 }}
                                                color="error"
                                                onClick={() => removeForm(setOtherAssetsForms, form.id)}
                                            >
                                                <Minus size={20} />
                                            </IconButton>

                                            <Grid size={4}>
                                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}><RequiredLabel>Asset Name</RequiredLabel></Typography>
                                                <TextField
                                                    placeholder="Enter the details"
                                                    fullWidth
                                                    sx={{ backgroundColor: 'white', borderRadius: '8px' }}
                                                    value={form.data.assetsName}
                                                    onChange={(e) => handleInputChange(setOtherAssetsForms, form.id, 'assetsName', e.target.value)}
                                                    error={!!errors[`assetsName-${form.id}`]}
                                                    helperText={errors[`assetsName-${form.id}`] || ''}
                                                />
                                            </Grid>

                                            <Grid size={4}>
                                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}><RequiredLabel>Asset description</RequiredLabel></Typography>
                                                <TextField
                                                    placeholder="Enter the details"
                                                    fullWidth
                                                    sx={{ backgroundColor: 'white', borderRadius: '8px' }}
                                                    value={form.data.description}
                                                    onChange={(e) => handleInputChange(setOtherAssetsForms, form.id, 'description', e.target.value)}
                                                    error={!!errors[`description-${form.id}`]}
                                                    helperText={errors[`description-${form.id}`] || ''}
                                                />
                                            </Grid>

                                            <Grid size={4}>
                                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}><RequiredLabel>Asset value</RequiredLabel></Typography>
                                                <TextField
                                                    placeholder="Enter the value"
                                                    fullWidth
                                                    sx={{ backgroundColor: 'white', borderRadius: '8px' ,  backgroundColor: 'white',
                                                        borderRadius: '8px',
                                                        '& input[type=number]': {
                                                            '-moz-appearance': 'textfield',
                                                        },
                                                        '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
                                                            '-webkit-appearance': 'none',
                                                            margin: 0,
                                                        },}}
                                                    value={form.data.value}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (/^\d{0,5}$/.test(value)) {
                                                            const intValue = parseInt(value, 10) || null;
                                                            handleInputChange(setOtherAssetsForms, form.id, 'value', intValue);
                                                            handleInputChange(setOtherAssetsForms, form.id, 'available_value', intValue);
                                                            handleInputChange(setOtherAssetsForms, form.id, 'balance_value', intValue);
                                                        }
                                                    }}
                                                    slotProps={{
                                                        input: {
                                                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                                        },
                                                    }}
                                                    error={!!errors[`value-${form.id}`]}
                                                    helperText={errors[`value-${form.id}`] || ''}
                                                />
                                            </Grid>

                                            <Grid size={4}>
                                                <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63', fontSize: '13px' }}>Other Information</Typography>
                                                <TextField
                                                    placeholder="Enter the info"
                                                    fullWidth
                                                    sx={{ backgroundColor: 'white', borderRadius: '8px' }}
                                                    value={form.data.information}
                                                    onChange={(e) => handleInputChange(setOtherAssetsForms, form.id, 'information', e.target.value)}
                                                    error={!!errors[`information-${form.id}`]}
                                                    helperText={errors[`information-${form.id}`] || ''}
                                                    slotProps={{
                                                        input: {
                                                            endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    )}
                </Box>
            </Box>

            <Box mt={4} textAlign="center">
                <Button
                    type="submit"
                    variant="contained"
                    startIcon={<PlusCircle size={20} />}
                    onClick={handleSubmit}
                    disabled={isLoading}
                    sx={{
                        padding: '15px 30px',
                        borderRadius: "8px",
                        backgroundColor: 'var(--primary-color)',
                        color: '#fff',
                        '&:hover': { backgroundColor: 'var(--primary-color)' }
                    }}
                >
                    Update Estate
                </Button>
            </Box>
        </Box>
    );
}

